import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";

type TestWebhookParams = {
	event: string;
	webhookId: string;
};

/**
 * TODO: we could just send it from the client,
 * instead of the backend?
 */
export default function useTestWebhook(shop: ShopDto) {
	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/webhooks/{webhookId}/{event}/test",
	);

	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	return useMutation({
		onSuccess: () => {
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async ({ event, webhookId }: TestWebhookParams) => {
			return mutation.mutateAsync({
				params: { path: { shopId: shop.id, webhookId, event } },
			});
		},
	});
}
